import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import DatePicker from '../../../components/DatePicker/index';
import Select from '../../../components/Select/index';
import {
    STATES,
    USD_WITH_DECIMAL_ATTR
} from '../../../services/constant/constant';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import MaskedInput from 'react-text-mask';
import { Filings } from '../services/Filings';

const usdWithDecimalMask = createNumberMask(USD_WITH_DECIMAL_ATTR);
class EditFilingForm extends Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    handleInputChange(event) {
        let { editFilingData, isEditable, updateFilingData } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            let tmpSelected = _.extend({}, editFilingData);
            tmpSelected[name] = value;
            updateFilingData(tmpSelected);
        }
    }

    handleSelectChange(name, value, valueKey) {
        let { editFilingData, updateFilingData } = this.props;
        let tmpSelected = _.extend({}, editFilingData);
        if (value !== null) {
            if (valueKey) {
                tmpSelected[name] = value[valueKey];
            } else {
                tmpSelected[name] = value[name];
            }
        } else {
            tmpSelected[name] = '';
        }
        updateFilingData(tmpSelected);
    }

    handleDateChange(name, value) {
        let { editFilingData, updateFilingData } = this.props;
        let tmpSelected = _.extend({}, editFilingData);
        if (value !== null) {
            tmpSelected[name] = value;
        } else {
            tmpSelected[name] = '';
        }
        updateFilingData(tmpSelected);
    }

    render() {
        let {
            editFilingData,
            filingInfoData,
            mailingMethods,
            clientData,
            stateData,
            isEditable,
            formRef
        } = this.props;

        return (
            <form ref={formRef}>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Status:&nbsp;&nbsp;</label>
                        <label>
                            {Filings.getFilingStatusName(
                                editFilingData.filingStatus
                            )}
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Trust Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="trustName"
                            value={filingInfoData.trustName}
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Portfolio Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="portfolioName"
                            value={filingInfoData.portfolioName}
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Class Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="className"
                            value={filingInfoData.className}
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Prospectus Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="prospectusName"
                            value={filingInfoData.prospectusName}
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>State</label>
                        <Select
                            labelKey="name"
                            valueKey="stateId"
                            name="stateId"
                            selectedValue={editFilingData.stateId}
                            onChange={() => {}}
                            options={STATES}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Is Priority</label>
                        <Select
                            name="isPriority"
                            labelKey="label"
                            valueKey="isPriority"
                            options={[
                                { label: 'Yes', isPriority: true },
                                { label: 'No', isPriority: false }
                            ]}
                            selectedValue={filingInfoData.isPriority}
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Request Date</label>
                        <DatePicker
                            name="requestDateTime"
                            value={filingInfoData.requestDateTime}
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>State Fee</label>
                        <MaskedInput
                            mask={usdWithDecimalMask}
                            className="form-control"
                            type="text"
                            name="stateFee"
                            value={
                                filingInfoData.stateFee || stateData.minimumFee
                            }
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Service Fee</label>
                        <MaskedInput
                            mask={usdWithDecimalMask}
                            className="form-control"
                            type="text"
                            name="serviceFee"
                            value={
                                filingInfoData.serviceFee ||
                                clientData.serviceFee
                            }
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Other Fee</label>
                        <MaskedInput
                            mask={usdWithDecimalMask}
                            className="form-control"
                            type="text"
                            name="otherFee"
                            value={
                                filingInfoData.otherFee || clientData.otherFee
                            }
                            onChange={() => {}}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Effective Date</label>
                        <DatePicker
                            name="effectiveDate"
                            value={editFilingData.effectiveDate}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Expiration Date</label>
                        <DatePicker
                            name="expirationDate"
                            value={editFilingData.expirationDate}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Is Sales Report</label>
                        <Select
                            name="isSalesReport"
                            labelKey="label"
                            valueKey="isSalesReport"
                            options={[
                                { label: 'Yes', isSalesReport: true },
                                { label: 'No', isSalesReport: false }
                            ]}
                            selectedValue={editFilingData.isSalesReport}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Date Sent To State</label>
                        <DatePicker
                            name="sentToStateDate"
                            value={editFilingData.sentToStateDate}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Hold Until Date</label>
                        <DatePicker
                            name="holdUntilDate"
                            value={editFilingData.holdUntilDate}
                            onChange={this.handleDateChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Permit Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="permitNumber"
                            value={editFilingData.permitNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Mailing Method</label>
                        <Select
                            name="mailingMethodType"
                            labelKey="enumName"
                            valueKey="enumId"
                            options={mailingMethods}
                            selectedValue={editFilingData.mailingMethodType}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Tracking Number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="trackingNumber"
                            value={editFilingData.trackingNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Check Number/ACH Confirm number</label>
                        <input
                            className="form-control"
                            type="text"
                            name="checkNumber"
                            value={editFilingData.checkNumber}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

EditFilingForm.propTypes = {
    editFilingData: PropTypes.object.isRequired,
    filingInfoData: PropTypes.object.isRequired,
    clientData: PropTypes.object.isRequired,
    stateData: PropTypes.object.isRequired,
    mailingMethods: PropTypes.array,
    updateFilingData: PropTypes.func,
    isEditable: PropTypes.bool
};

EditFilingForm.defaultProps = {
    isEditable: true
};

export default EditFilingForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/EditFilingForm.js